// extracted by mini-css-extract-plugin
module.exports = {"container":"PromotionalMessages_container__qzLhD","message":"PromotionalMessages_message__mt1Qk","messageLink":"PromotionalMessages_messageLink__rpQdp"};